import { IPaginationStore, IPaginationStoreAction, PaginationActionTypes } from './types';

export const paginationReducer = (
  store: IPaginationStore,
  action: IPaginationStoreAction<PaginationActionTypes, Partial<IPaginationStore>>
): IPaginationStore => {
  switch (action.type) {
    case PaginationActionTypes.SET_DISPATCH:
      return {
        ...store,
        dispatch: action.payload.dispatch,
      };
    case PaginationActionTypes.SET_SHOW_ALL:
      return {
        ...store,
        showAll: !!action.payload.showAll,
      };
    case PaginationActionTypes.TOGGLE_SHOW_ALL:
      return {
        ...store,
        showAll: !store.showAll,
      };
    default:
      return store;
  }
};
